import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="contact-form"
export default class extends Controller {
  static targets = [ "kind", "value", "submit" ]

  connect() {
    this.updateValueInput()
  }

  submitStart() {
    this.submitTarget.disabled = true
  }

  submitEnd() {
    this.submitTarget.disabled = false
    this.element.reset()
    this.updateValueInput()
  }

  changeKind() {
    this.valueTarget.value = ""
    this.updateValueInput()
  }

  updateValueInput() {
    const kind = this.kindTarget.value
    const placeholders = {
      email: "nome@exemplo.com",
      phone: "(00) 00000-0000",
      whatsapp: "+55 (00) 00000-0000"
    }

    this.valueTarget.dataset.inputMaskTypeValue = kind
    this.valueTarget.placeholder = placeholders[kind] || ""
    this.valueTarget.inputMode = kind === "email" ? "email" : "tel"
  }
}
